import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { Popup } from '.'
import { Button } from '../html/button'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import TextEllipsis from '../textEllipsis'
import classes from './index.module.scss'

export const PopupAction = ({
  isShow,
  title,
  btnSubmit,
  btnCancel,
  btnTertiary,
  handleClose,
  footerStyle,
  children,
  zIndexPopup,
  appendStyle,
  disableKeyDown,
  headerStyle,
}) => {
  useEffect(() => {
    const handleKeydown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        !btnSubmit.disabled && btnSubmit?.event()
      }
    }

    if (isShow && btnSubmit?.event && !disableKeyDown) {
      document.addEventListener('keydown', handleKeydown)
    } else {
      document.removeEventListener('keydown', handleKeydown)
    }

    return () => {
      document.removeEventListener('keydown', handleKeydown)
    }
  }, [isShow, btnSubmit?.event])

  return (
    <>
      {isShow && (
        <Popup appendStyleContent={appendStyle} zIndexPopup={zIndexPopup}>
          <div className={['w100', classes.popupAction].join(' ')}>
            <Element
              className={[
                'dFlex justifyContentBetween alignItemsCenter',
                classes.header,
              ].join(' ')}
              style={{
                ...headerStyle,
                borderBottom: '1px solid #e5e5e8',
              }}
            >
              <Element
                elementName="span"
                className={classes.titleHeader}
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  lineHeight: '24px',
                  color: '#0553A5',
                  width: `calc(100% - 30px)`,
                }}
              >
                {title ? (
                  <TextEllipsis zIndexTooltip={7} text={title} isI18n />
                ) : (
                  ''
                )}
              </Element>
              <Element onClick={handleClose}>
                <Icon
                  className="icon-delete"
                  style={{ fontSize: 12, color: '#9C9C9C' }}
                />
              </Element>
            </Element>
            <div className={['w100', classes.content].join(' ')}>
              {children}
            </div>
            <div
              style={footerStyle}
              className={['dFlex justifyContentEnd gap1', classes.footer].join(
                ' ',
              )}
            >
              {btnTertiary && (
                <Button
                  label={btnTertiary.label}
                  style={{
                    border: '1px solid #D5D5D5',
                    backgroundColor: '#FFFFFF',
                    color: btnSubmit.disabled ? '#9C9C9C' : '#3a414b',
                    ...btnTertiary.style,
                  }}
                  disabled={btnTertiary.disabled}
                  action={btnTertiary.event}
                  isI18n={btnTertiary.isI18n}
                />
              )}
              {btnCancel && (
                <Button
                  label={btnCancel.label}
                  style={{
                    border: '1px solid #D5D5D5',
                    backgroundColor: '#FFFFFF',
                    color: btnCancel.disabled ? '#9C9C9C' : '#3a414b',
                    ...btnCancel.style,
                  }}
                  disabled={btnCancel.disabled}
                  action={btnCancel.event}
                  isI18n={btnCancel.isI18n}
                />
              )}
              {btnSubmit && (
                <Button
                  label={btnSubmit.label}
                  style={{
                    border: 'none',
                    backgroundColor: btnSubmit.disabled ? '#D5D5D5' : '#2c73e8',
                    color: btnSubmit.disabled ? '#9C9C9C' : '#ffffff',
                    ...btnSubmit.style,
                  }}
                  disabled={btnSubmit.disabled}
                  action={btnSubmit.event}
                  isI18n={btnSubmit.isI18n}
                />
              )}
            </div>
          </div>
        </Popup>
      )}
    </>
  )
}

PopupAction.propTypes = {
  isShow: PropTypes.bool.isRequired,
  title: PropTypes.string,
  btnTertiary: PropTypes.shape({
    label: PropTypes.string,
    event: PropTypes.func,
    isI18n: PropTypes.bool,
    style: PropTypes.object,
  }),
  btnCancel: PropTypes.shape({
    label: PropTypes.string,
    event: PropTypes.func,
    isI18n: PropTypes.bool,
    style: PropTypes.object,
  }),
  btnSubmit: PropTypes.shape({
    label: PropTypes.string,
    event: PropTypes.func,
    isI18n: PropTypes.bool,
    style: PropTypes.object,
  }),
  handleClose: PropTypes.func.isRequired,
  zIndexPopup: PropTypes.number,
  children: PropTypes.node,
  appendStyle: PropTypes.object,
  disableKeyDown: PropTypes.bool,
  headerStyle: PropTypes.object,
}

PopupAction.defaultProps = {
  zIndexPopup: 13,
  footerStyle: {},
  disableKeyDown: false,
  headerStyle: {},
}
